/* @flow */

export const SELF = 'SELF';
export const ALL_USERS = 'ALL_USERS';

export const USER_AUTOCOMPLETE = 'USER_AUTOCOMPLETE';
